define('models/Podio.Models.PeopleFinder',['require','underscore','lib/backbone/Backbone.PodioModel'],function(require) {

  var _ = require('underscore');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  return PodioModel.extend({

    defaults: function() { return {
      user: [],
      space: [],
      mail: [],
      profile: [],
      external: []
    }; },

    initialize: function() {
      this.idHash = {};
    },

    addItem: function(item, bucket) {
      var col = this.get(bucket);

      if ( !this.idHash[bucket] ) {
        this.idHash[bucket] = {};
      }

      if (this.idHash[bucket][item.id] ) {
        return; // Already added
      }

      col.push(item);
      this.idHash[bucket][item.id] = item;

      // Save
      var data = {};
      data[bucket] = col;
      this.set(data);
    },

    removeItem: function(item, bucket) {
      var col = this.get(bucket);

      col = _.reject(col, function(i) {
        return i.id === item.id;
      });

      // Save
      var data = {};
      data[bucket] = col;
      this.set(data);

      if (!_.isEmpty(this.idHash[bucket])) {
        delete this.idHash[bucket][item.id];
      }
    }

  });

});

